export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14764.3d511783.jpg";